module.exports = __webpack_public_path__ + "static/media/parking.16cfa3eb.svg";